import protectedAxios from '../auth/axios.js';
import { mapState } from 'vuex';

export const cacheMixin = {
    computed: {
        ...mapState(['pripad']),
    },
    methods: {
        nacitajCache(newId = null,cisloPredmetu = null){
            let _newId = newId ?? this.pripad.newId;
            let _cisloPredmetu = cisloPredmetu ?? this.pripad.cisloPredmetu;
            return protectedAxios
              .get(
                `/pripady/${_newId}/predmety/${_cisloPredmetu}/load-cache`
              ).then(_ => {
                if(this.pripad.cisloPredmetu != null && this.pripad.cisloPredmetu != _.data)
                    this.pripad.cisloPredmetu = _.data;
                return {"newId":_newId,"cisloPredmetu":_.data};
              });
        },
        resetCache() {
            return protectedAxios.post(`controls/resetcache`, null, {
                headers: {
                'Content-Type': 'application/json',
                },
            });
        }
    }
}